import type { ProviderSlot } from "@src/interfaces/provider.interface";
import { dayjs } from "@uhg-abyss/web/tools/dayjs";

const toSlotStartMinutes = (slot: ProviderSlot): number | null => {
  const [hoursRaw, minutesRaw = "0"] = slot.start_time.split(":");
  const hours = Number(hoursRaw);
  const minutes = Number(minutesRaw);

  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
    return null;
  }

  return hours * 60 + minutes;
};

export const filterIsoDatesBySelectedWeekdays = (
  isoDates: string[],
  selectedWeekdays: string[] | undefined,
): string[] => {
  if (!selectedWeekdays || selectedWeekdays.length === 0) {
    return [...isoDates];
  }

  const selectedWeekdaySet = new Set(selectedWeekdays);

  return isoDates.filter((isoDate) => {
    const weekday = dayjs(isoDate).format("dddd");
    return selectedWeekdaySet.has(weekday);
  });
};

export const filterSlotsByHourRange = (
  slots: ProviderSlot[],
  startHour: number | undefined,
  endHour: number | undefined,
): ProviderSlot[] => {
  if (typeof startHour !== "number" && typeof endHour !== "number") {
    return [...slots];
  }

  const startMinutes = typeof startHour === "number" ? startHour * 60 : undefined;
  const endMinutes = typeof endHour === "number" ? endHour * 60 : undefined;

  return slots.filter((slot) => {
    const slotStartMinutes = toSlotStartMinutes(slot);

    // Keep malformed times visible rather than silently dropping backend data.
    if (slotStartMinutes === null) {
      return true;
    }

    if (typeof startMinutes === "number" && slotStartMinutes < startMinutes) {
      return false;
    }

    if (typeof endMinutes === "number" && slotStartMinutes > endMinutes) {
      return false;
    }

    return true;
  });
};
